/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import dayjs, { Dayjs } from 'dayjs'
import React, { MouseEvent, useMemo } from 'react'
import { EVENT_TYPES } from '../../../constants'
import { IEvent } from '../../../types'
import CustomTooltip from '../common/CustomTooltip'
import styles from '../SAPPCalendar.module.css'
import WeeklyEvent from './WeeklyEvent'
import clsx from 'clsx'

interface IWeeklyCellProps {
  events: IEvent[]
  date: Dayjs
  onOpenDetail?: (date: Date, events: IEvent[]) => void
  onOpenCreate?: (date: Date) => void
  onEventDetail?: (event: IEvent) => void
  eventDetail?: {event: IEvent | null, date: Dayjs} | null
  setEventDetail?: (params: {event: IEvent | null, date: Dayjs}) => void
  overlapMap?: Record<string, { count: number; index: number }>
}

// Overlap đã tính ở WeeklyCalendar theo từng ngày
const WeeklyCell = ({
  events,
  date,
  onOpenDetail,
  onOpenCreate,
  onEventDetail,
  eventDetail,
  setEventDetail,
  overlapMap,
}: IWeeklyCellProps) => {
  const isToday = dayjs().isSame(date, 'day')

  const handleOpenCreateModal = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) return

    onOpenCreate && onOpenCreate(dayjs(date).toDate())
  }

  events.sort((a, b) =>
    a.type === EVENT_TYPES.BUSY && b.type !== EVENT_TYPES.BUSY ? 1 : -1
  )

  const renderWeeklyEvent = useMemo(() => {
    const isAllDay = events.some((item: IEvent) => item.isAllDay)
    if (isAllDay && events.length > 1) {
      return (
        <React.Fragment>
          <WeeklyEvent
            event={events[0]}
            onOpenDetail={onOpenDetail}
            onEventDetail={onEventDetail}
            zIndex={1}
            isAllDay={isAllDay}
            date={date}
          />
          <div className={styles['see-more']}>
            <CustomTooltip
              placement='bottom'
              title={
                <div className={styles['calendar-tooltip']}>
                  {events.slice(1, events.length).map((event, index) => (
                    <WeeklyEvent
                      event={event}
                      onOpenDetail={onOpenDetail}
                      onEventDetail={onEventDetail}
                      key={index + 1}
                      zIndex={index + 1}
                      isAllDay={isAllDay}
                      setEventDetail={setEventDetail}
                      isOnDetail={eventDetail?.event?.id === event.id && eventDetail.date.isSame(date, 'day')}
                      date={date}
                    />
                  ))}
                </div>
              }
            >
              +{Math.max(events.length - 1, 0)} More
            </CustomTooltip>
          </div>
        </React.Fragment>
      )
    }
    // Overlap per day đã tính ở trên, map cho từng event
    return events.map((event, idx) => {
      const info = overlapMap?.[event.id]
      const count = info?.count ?? 1
      const index = info?.index ?? 0
      return (
        <WeeklyEvent
          key={event.id}
          event={event}
          onOpenDetail={onOpenDetail}
          onEventDetail={onEventDetail}
          zIndex={idx + 1}
          isAllDay={isAllDay}
          setEventDetail={setEventDetail}
          isOnDetail={
            eventDetail?.event?.id === event.id &&
            eventDetail.date.isSame(date, 'day')
          }
          date={date}
          overlapCount={count}
          overlapIndex={index}
        />
      )
    })
  }, [events])

  return (
    <div
      className={clsx(
        styles['weekly-calendar__cell'], 
       isToday  ? styles['bg-active'] : styles['bg-white'],
      )}
      onClick={handleOpenCreateModal}
    >
      {renderWeeklyEvent}
    </div>
  )
}

export default WeeklyCell
